import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import {
  LOAD_FOLDER_GENERAL_INFO_STARTED,
  LOAD_FOLDER_GENERAL_INFO_SUCCESS
} from "features/folder/edit/generalData/info/actionTypes";
import { RESET_FINANCED_OFFERS_FOR_CONTRACT_GENERATION } from "features/document/edit/contractGeneration/actionTypes";

export function loadFolderHeader(documentId, siteId) {
  return async (dispatch, getState) => {
    let folderHeader = getState().currentFolder.header;
    if (folderHeader.documentId === documentId && folderHeader.loaded) return folderHeader;

    try {
      if (folderHeader.loading === false) {
        dispatch({ type: actionTypes.LOAD_FOLDER_HEADER_STARTED });
        dispatch({ type: LOAD_FOLDER_GENERAL_INFO_STARTED });

        folderHeader = await dispatch(sendHttpRequest(api.getFolderHeader(documentId, siteId)));
        const { generalInfo, client } = folderHeader;

        delete folderHeader.generalInfo;
        delete folderHeader.client;

        dispatch({
          type: actionTypes.LOAD_FOLDER_HEADER_SUCCESS,
          payload: { folderHeader: { ...folderHeader, client: { clientId: client.clientId } } }
        });
        dispatch({ type: LOAD_FOLDER_GENERAL_INFO_SUCCESS, payload: { generalInfo } });
        dispatch({ type: actionTypes.LOAD_FOLDER_PARTNER_SUCCESS, payload: { partner: { ...client } } });
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadFolderReports(documentId, siteId) {
  return async dispatch => {
    try {
      let folderReports = await dispatch(sendHttpRequest(api.loadFolderReports(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_FOLDER_REPORTS_SUCCESS, payload: { folderReports } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadFolderWarnings(documentId, siteId) {
  return async dispatch => {
    try {
      let documentWarnings = await dispatch(sendHttpRequest(api.loadFolderWarnings(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_FOLDER_WARNINGS_SUCCESS, payload: { documentWarnings } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function resetCurrentFolder(documentId, siteId) {
  return dispatch => {
    try {
      dispatch({ type: actionTypes.RESET_CURRENT_FOLDER, payload: { documentId, siteId } });
      dispatch({ type: RESET_FINANCED_OFFERS_FOR_CONTRACT_GENERATION, payload: { documentId, siteId } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
